import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    promo: null,  // данные выбранного промо
    isEditMode: false,  // режим редактирования
    editMode: 'full',   // 'full' = всё можно менять, 'limited' = только tasks и duration
};

const selectedPromoSlice = createSlice({
    name: 'selectedPromo',
    initialState,
    reducers: {
        setSelectedPromo: (state, action) => {
            state.promo = action.payload;
        },
        clearSelectedPromo: (state) => {
            state.promo = null;
            state.isEditMode = false;
            state.editMode = 'full';
        },
        setEditMode: (state, action) => {
            // action.payload = { isEditMode: true/false, editMode: 'full'/'limited' }
            state.isEditMode = action.payload.isEditMode;
            state.editMode = action.payload.editMode || 'full';
        },
        clearEditMode: (state) => {
            state.isEditMode = false;
            state.editMode = 'full';
        },
    },
});

export const { setSelectedPromo, clearSelectedPromo, setEditMode, clearEditMode } = selectedPromoSlice.actions;
export default selectedPromoSlice.reducer;
